import {
  type MingcuteLineIconKey,
  mingcuteLineIconKeys,
} from './mingcute-line-icon-catalog.generated';

export const coreAppIconKeys = [
  'arrow-left',
  'arrow-right',
  'arrow-up-right',
  'award',
  'bar-chart3',
  'blocks',
  'book',
  'bot',
  'bug',
  'calendar',
  'camera',
  'chart-column',
  'check',
  'check-square',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'circle-check',
  'circle-help',
  'circle-user-round',
  'clapperboard',
  'clock',
  'clock3',
  'cloud-upload',
  'coins',
  'cpu',
  'credit-card',
  'crown',
  'download',
  'eraser',
  'eye',
  'eye-off',
  'file-image',
  'file-text',
  'filter',
  'flux',
  'seedance',
  'gift',
  'globe',
  'grid',
  'grid2x2',
  'history',
  'home',
  'image',
  'image-up',
  'info',
  'laptop',
  'laptop-minimal',
  'layers',
  'layers3',
  'layout-dashboard',
  'layout-grid',
  'list',
  'loader2',
  'lock',
  'log-in',
  'log-out',
  'mail',
  'maximize',
  'menu',
  'message-circle',
  'mic-vocal',
  'minimize',
  'monitor',
  'moon',
  'moon-star',
  'more-1',
  'more-horizontal',
  'mouse-pointer-click',
  'package',
  'palette',
  'panel-left',
  'paperclip',
  'pencil',
  'play',
  'plus',
  'quote',
  'refresh-cw',
  'scan-eye',
  'search',
  'send',
  'settings',
  'settings2',
  'share-2',
  'shield',
  'shield-alert',
  'shield-check',
  'smartphone',
  'sparkles',
  'star',
  'sun',
  'sun-medium',
  'terminal',
  'thumbs-down',
  'thumbs-up',
  'trash2',
  'trending-down',
  'triangle-alert',
  'truck',
  'upload',
  'user',
  'user2',
  'user-round',
  'users',
  'users-round',
  'video',
  'wand2',
  'wand-sparkles',
  'wrench',
  'x',
  'zap',
] as const;

export const appIconKeys = Array.from(
  new Set<string>([...coreAppIconKeys, ...mingcuteLineIconKeys])
);

export type CoreAppIconKey = (typeof coreAppIconKeys)[number];
export type AppIconKey = CoreAppIconKey | MingcuteLineIconKey;

const appIconKeySet = new Set(appIconKeys);
const mingcuteLineIconKeySet = new Set<string>(mingcuteLineIconKeys);

export function isAppIconKey(value: unknown): value is string {
  return typeof value === 'string' && appIconKeySet.has(value);
}

export function isMingcuteLineIconKey(
  value: unknown
): value is MingcuteLineIconKey {
  return typeof value === 'string' && mingcuteLineIconKeySet.has(value);
}

export function resolveAppIconKey(value: unknown): string | null {
  if (isAppIconKey(value)) {
    return value;
  }
  if (typeof value !== 'string' || !value.endsWith('-line')) {
    return null;
  }

  const keyWithoutLineSuffix = value.slice(0, -'-line'.length);
  return isAppIconKey(keyWithoutLineSuffix) ? keyWithoutLineSuffix : null;
}

export function normalizeAppIconName(name: string | null | undefined) {
  return (
    name
      ?.trim()
      .replace(/[^a-z0-9]/gi, '')
      .toLowerCase() ?? ''
  );
}

const registeredAppIconNames = new Set(appIconKeys.map(normalizeAppIconName));

export function isRegisteredAppIconName(name: string | null | undefined) {
  const normalized = normalizeAppIconName(name);
  return Boolean(normalized && registeredAppIconNames.has(normalized));
}
